'use client'

import { useEffect, useRef, useContext } from 'react'
import IframeResizer from '@/components/IFrameResizer/IFrameResizer'
import { MetaDataContext } from '@/context/MetadataContext'
import { reloadAds } from '@/libs/AdAlliance/AdAlliance.lib'

export type WidgetIntegrationSportProps = {
  readonly model?: {
    readonly meta?: {
      trackingPath?: string
    }
    readonly flavours?: [
      {
        readonly flavourData?: string
        readonly flavourPattern?: {
          readonly suffix?: string
        }
      },
    ]
  }
}

const IntegrationSport = ({ item }: { item: WidgetIntegrationSportProps }) => {
  const metaData = useContext(MetaDataContext)

  const { model } = item

  const isInitialFrame = useRef<boolean>(true)
  const iframeBasePath = 'https://sportdaten.n-tv.de/web/'
  const initialIframeUrl =
    typeof model?.flavours?.[0].flavourPattern?.suffix === 'string' &&
    model?.flavours[0].flavourData === 'sport-results'
      ? iframeBasePath + model.flavours[0].flavourPattern.suffix
      : undefined

  useEffect(() => {
    window.addEventListener('message', function (e) {
      if (e.origin !== new URL(iframeBasePath).origin) return
      if (e.data.ntvsport) {
        if (e.data.url !== initialIframeUrl) isInitialFrame.current = false
        if (!isInitialFrame.current) {
          window.scrollTo(0, 0)
          reloadAds()
          if (metaData?.model?.trackingPath) {
            //toDo track pageview
            //console.log(metaData.model.trackingPath);
          }
          try {
            const selfBasePath = new URL(location.href).origin + '/sport/ergebnisse/'
            const iframePathname = new URL(e.data.url).pathname

            const relativePath = iframePathname.split('/').slice(2).join('/').replace(/^\/+/, '') // remove leading slashes

            const finalUrl = new URL(relativePath, selfBasePath).toString()

            history.replaceState(null, '', finalUrl)
          } catch (e) {
            console.error(e)
          }
        }
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {initialIframeUrl && <IframeResizer src={initialIframeUrl} title="Sporttabellen" loading="eager" height="800" />}
    </>
  )
}

export default IntegrationSport
